import { gsap } from '../animations';

/**
 * Parallasse verticale di un'immagine full-bleed mentre la sezione attraversa il
 * viewport (scrub). Lo spazio per il movimento è dato dall'immagine sovradimensionata
 * (top -12% / height 124%). Riusato da blocchi diversi (chiusura, dove-siamo).
 *
 * @param {string} selector Selettore delle sezioni contenitore.
 */
export function initParallaxImg( selector ) {
	// Con reduced-motion l'immagine resta ferma (è già centrata e a copertura).
	if ( window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches ) {
		return;
	}

	document.querySelectorAll( selector ).forEach( ( section ) => {
		const imgs = section.querySelectorAll( 'img[data-season]' );
		if ( ! imgs.length ) {
			return;
		}

		gsap.fromTo(
			imgs,
			{ yPercent: -8 },
			{
				yPercent: 8,
				ease: 'none',
				scrollTrigger: {
					trigger: section,
					start: 'top bottom',
					end: 'bottom top',
					scrub: true,
					// will-change solo mentre la sezione è nel viewport: niente layer GPU a riposo.
					onToggle: ( self ) => {
						const wc = self.isActive ? 'transform' : 'auto';
						imgs.forEach( ( img ) => {
							img.style.willChange = wc;
						} );
					},
				},
			}
		);
	} );
}
